import { Company } from './company';
import { RessoureGroup } from './ressoure-group';
import { WorkingHour } from './working-hour';

// Location is Employee in DB
export interface Location {
  _id?: string;
  fullname: string;
  email: string;
  // avatar: string | File;
  // updatedAvatar?: File;
  company: Company | string;
  // break_time: {
  //   duration: number;
  //   from: string;
  //   to: string;
  // };
  // primary_color: string;
  seats?: number;
  street?: string;
  visible: boolean;
  secondary_color: string;
  working_hours: WorkingHour[];
  weekly_period_count: number;
  ressource_group: RessoureGroup | string;
  // eslint-disable-next-line @typescript-eslint/member-ordering
  [key: string]: any;
  online: boolean;
}

export function getEmptyLocation() {
  return {
    fullname: "",
    street: "",
    city: "",
    zipcode: "",
    company: "",
    building_number: "",
    online: false
  }
}
